export const MAX_INVITATIONS_COUNT = 10;
